import { render, staticRenderFns } from "./PreApprovalLetterCreate.vue?vue&type=template&id=2a282dc8&scoped=true&"
import script from "./PreApprovalLetterCreate.vue?vue&type=script&lang=js&"
export * from "./PreApprovalLetterCreate.vue?vue&type=script&lang=js&"
import style0 from "./PreApprovalLetterCreate.vue?vue&type=style&index=0&id=2a282dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a282dc8",
  null
  
)

export default component.exports